import type { LitElement, ReactiveController, ReactiveControllerHost } from 'lit'
import { subscribe, unsubscribe } from './subscribers'

class LocaleController implements ReactiveController {
  private readonly host: ReactiveControllerHost & LitElement

  constructor(host: ReactiveControllerHost & LitElement) {
    this.host = host
    host.addController(this)
  }

  hostConnected() {
    subscribe(this.host)
  }

  hostDisconnected() {
    unsubscribe(this.host)
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const localized = () => (clazz: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  clazz.addInitializer((instance: any) => {
    new LocaleController(instance)
  })
  return clazz
}
